import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CheckCircleBlue: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="currentColor" />
    <path
      d="M15 7L8.125 14L5 10.8182"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
